/* ==========================================================================
   Lawn Tips - trackpad / wheel swiping for the carousels

   NOT dark-mode: this runs in both themes.

   Why it was needed: a two-finger trackpad swipe is a WHEEL event, not a
   touch event. Swiper listens for touch and mouse-drag out of the box, so
   trackpad swipes did nothing. The bundled Swiper build already ships the
   mousewheel module, it is just switched off (verified live:
   mousewheelModule true, mousewheelEnabled false), so this only has to
   enable it on each instance.

   Safety: forceToAxis means only genuinely horizontal gestures move the
   carousel, so ordinary vertical page scrolling is never hijacked.
   releaseOnEdges hands scrolling back to the page at the ends, and
   thresholdDelta ignores the small sideways jitter of a vertical swipe.

   Covers every carousel family on the site: the Section Store sliders and
   slideshows, all three YouTube sections, and any plain .swiper.
   ========================================================================== */
(function () {
  'use strict';

  var SELECTOR = [
    '.swiper',
    '[class*="slider-slider-"]',
    '[class*="custom-slideshow-slider"]',
    '[class*="yt-carousel__viewport"]',
    '[class*="yt-picks__viewport"]',
    '[class*="__viewport"]'
  ].join(',');

  function enableOn(el) {
    var sw = el.swiper;
    if (!sw || sw.destroyed || sw.__ltWheelDone) return;
    if (!sw.mousewheel || typeof sw.mousewheel.enable !== 'function') return;

    var existing = sw.params.mousewheel || {};
    sw.params.mousewheel = {
      enabled: true,
      forceToAxis: true,
      releaseOnEdges: existing.releaseOnEdges !== false,
      thresholdDelta: 6,
      thresholdTime: 0,
      sensitivity: 1,
      eventsTarget: existing.eventsTarget || el
    };

    try {
      sw.mousewheel.enable();
      sw.__ltWheelDone = true;
      /* Make it obvious the strip is draggable/swipeable */
      el.style.cursor = 'grab';
      el.addEventListener('pointerdown', function () { el.style.cursor = 'grabbing'; });
      el.addEventListener('pointerup', function () { el.style.cursor = 'grab'; });
    } catch (e) {
      /* if a build lacks the module, leave the carousel exactly as it was */
    }
  }

  function sweep() {
    document.querySelectorAll(SELECTOR).forEach(enableOn);
  }

  function boot() {
    sweep();
    /* Swiper initialises after its own CDN script loads, and several of
       these carousels sit below the fold, so re-sweep rather than assume
       every instance exists at DOMContentLoaded. */
    setTimeout(sweep, 1200);
    setTimeout(sweep, 3000);
    setTimeout(sweep, 6000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor re-renders sections and rebuilds their Swipers */
  document.addEventListener('shopify:section:load', function () {
    setTimeout(sweep, 400);
  });
})();

/* ==========================================================================
   Whole-card clicking for the homepage product slider

   In the ss_featured_collection slides only the "Shop Now" button is a real
   link. The product photo, title and description are plain divs, so clicking
   the product itself did nothing. This makes the whole slide clickable,
   reusing the href already on that slide's own button, so it can never point
   at the wrong product.

   Deliberately a click handler rather than wrapping things in <a> tags:
   restructuring slide markup risks breaking Swiper's layout, and the button
   anchor already gives crawlers a real link. Drags are ignored via a small
   movement threshold so swiping never fires a navigation.
   ========================================================================== */
(function () {
  'use strict';

  var SLIDE = '[class*="collection-slide-"]';
  var BUTTON = 'a[class*="collection-button-"]';

  function targetHref(slide) {
    var a = slide.querySelector(BUTTON);
    return a ? a.getAttribute('href') : null;
  }

  function markClickable(slide) {
    if (slide.__ltClickable) return;
    if (!targetHref(slide)) return;
    slide.__ltClickable = true;
    slide.style.cursor = 'pointer';
    /* the photo and title should feel clickable too */
    slide.querySelectorAll('[class*="collection-image-"], [class*="collection-title-"]').forEach(function (el) {
      el.style.cursor = 'pointer';
    });
  }

  var downX = 0, downY = 0, moved = false;

  document.addEventListener('pointerdown', function (e) {
    var slide = e.target.closest && e.target.closest(SLIDE);
    if (!slide) return;
    downX = e.clientX; downY = e.clientY; moved = false;
  }, true);

  document.addEventListener('pointermove', function (e) {
    if (Math.abs(e.clientX - downX) > 8 || Math.abs(e.clientY - downY) > 8) moved = true;
  }, true);

  document.addEventListener('click', function (e) {
    if (moved) return;                       /* it was a swipe, not a click */
    var slide = e.target.closest && e.target.closest(SLIDE);
    if (!slide) return;
    /* let real links and buttons behave normally */
    if (e.target.closest('a, button, input, select, textarea, [role="button"]')) return;
    var href = targetHref(slide);
    if (!href) return;
    window.location.href = href;
  });

  function sweepSlides() {
    document.querySelectorAll(SLIDE).forEach(markClickable);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sweepSlides);
  } else {
    sweepSlides();
  }
  setTimeout(sweepSlides, 1500);
  setTimeout(sweepSlides, 4000);
  document.addEventListener('shopify:section:load', function () { setTimeout(sweepSlides, 400); });
})();
